import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGPropsSubType extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
}

const AdvisorTeamIcon: React.FC<SVGPropsSubType> = ({ width, height, fill, ...props }) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = fill?.trim() ? fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";

  return (
    <svg
      width={width || 18}
      height={height || 21}
      viewBox="0 0 18 21"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.19596 4.34961L6.43628 13.3998L8.97487 14.9896L11.5635 13.361L9.90397 4.34961"
        fill={finalColor}
      />
      <path
        d="M14.7665 3.90533L16.4858 4.90536C17.4235 5.45107 18 6.44525 18 7.52019V14.5188C18 15.5937 17.424 16.5879 16.4858 17.1336L13.994 18.5826L10.5608 20.579C9.59777 21.139 8.40276 21.139 7.43976 20.579L1.51422 17.1331C0.575974 16.5884 0 15.5937 0 14.5188V7.52019C0 7.51063 0 7.50213 0.00107659 7.49256C0.00968928 6.42771 0.584048 5.44628 1.51422 4.90482L3.31696 3.85645L3.29436 14.1633L8.95344 17.7638L14.8208 14.1633L14.767 3.90427L14.7665 3.90533Z"
        fill={finalColor}
      />
      <path
        d="M9.04705 0L11.0307 1.66954L9.93201 3.61539H8.16533L6.96924 1.66954L9.04705 0Z"
        fill={finalColor}
      />
    </svg>
  );
};

export default AdvisorTeamIcon;
